<template>
  <div id="app">
    <v-app>
      <app-header></app-header>
      <app-drawer></app-drawer>
      <main>
        <router-view></router-view>
      </main>
      <app-fab></app-fab>
      <app-footer></app-footer>
    </v-app>
  </div>
</template>

<script>
  import Header from './components/Header.vue'
  import Drawer from './components/Drawer.vue'
  import Fab from './components/Fab.vue'
  import Footer from './components/Footer.vue'
  export default {
    components: {
      'app-header': Header,
      'app-drawer': Drawer,
      'app-fab': Fab,
      'app-footer': Footer
    }
  }
</script>

<style>
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-size: 18px;
}

a {
  text-decoration: none;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #FFF;
}

main {
  text-align: center;
  /*margin-top: 65px;*/
}
</style>



// WEBPACK FOOTER //
// App.vue?b1f81946